const ResourcesLinks = [
  {
    category: 'What is a mastermind?',
    articles: [
      {
        title: 'Peer Mentoring - Entrepreneur',
        url: 'https://www.entrepreneur.com/topic/peer-mentoring',
      },
      {
        title: 'What is a mastermind group, and how do you find it?',
        url: 'https://www.tonyrobbins.com/business/mastermind-group/',
      },
      {
        title: '9 Vistage Misconceptions Keeping you from Great Leadership',
        url: 'https://musiccityceos.com/blog/articles/9-vistage-misconceptions-keeping-you-from-great-leadership/',
      },
    ],
  },
  {
    category: 'Should you join a mastermind?',
    articles: [
      {
        title: '10 Reasons Why Business Owners Should Consider Joining A Peer Advisory Board - Forbes',
        url: 'https://www.forbes.com/sites/forbescoachescouncil/2020/09/17/10-reasons-why-business-owners-should-consider-joining-a-peer-advisory-board/?sh=12a6e4e6bd6b',
      },
      {
        title: '10 Reasons Why Leading Entrepreneurs Join a Peer Advisory Board - Entrepreneur',
        url: 'https://www.entrepreneur.com/article/428004',
      },
      {
        title: '7 Reasons To Join A Mastermind Group - Forbes',
        url: 'https://www.forbes.com/sites/chicceo/2013/10/21/7-reasons-to-join-a-mastermind-group/?sh=7934e7075deb',
      },
    ],
  },
  {
    category: '',
    articles: [],
  },
];

export default ResourcesLinks;
